import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  tr: {
    // Navigation
    dashboard: 'Kontrol Paneli',
    assessments: 'Değerlendirmeler',
    reports: 'Raporlar',
    companies: 'Şirketler',
    settings: 'Ayarlar',
    logout: 'Çıkış',
    
    // Auth
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    email: 'E-posta',
    password: 'Şifre',
    fullName: 'Ad Soyad',
    confirmPassword: 'Şifre Tekrar',
    forgotPassword: 'Şifremi Unuttum',
    noAccount: 'Hesabınız yok mu?',
    hasAccount: 'Zaten hesabınız var mı?',
    
    // Landing
    heroTitle: 'Dijital Olgunluk Değerlendirme Platformu',
    heroSubtitle: 'Şirketinizin dijital dönüşüm yolculuğunu bilimsel bir çerçeveyle ölçün, benchmark\'layın ve kurumsal seviyede danışmanlık raporları alın.',
    startAssessment: 'Değerlendirmeye Başla',
    learnMore: 'Daha Fazla Bilgi',
    
    // Dashboard
    welcomeBack: 'Hoş Geldiniz',
    totalAssessments: 'Toplam Değerlendirme',
    completedAssessments: 'Tamamlanan',
    averageScore: 'Ortalama GDMII',
    companiesCount: 'Kayıtlı Şirket',
    recentActivity: 'Son Aktiviteler',
    quickActions: 'Hızlı İşlemler',
    newAssessment: 'Yeni Değerlendirme',
    viewReports: 'Raporları Görüntüle',
    
    // Assessment
    startNewAssessment: 'Yeni Değerlendirme Başlat',
    continueAssessment: 'Devam Et',
    selectCompany: 'Şirket Seçin',
    assessmentProgress: 'Değerlendirme İlerlemesi',
    questionsAnswered: 'Yanıtlanan Soru',
    currentPillar: 'Mevcut Alan',
    nextQuestion: 'Sonraki Soru',
    previousQuestion: 'Önceki Soru',
    submitAssessment: 'Değerlendirmeyi Tamamla',
    
    // Pillars
    digitalStrategy: 'Dijital Strateji & Liderlik',
    technologyInfrastructure: 'Teknoloji Altyapısı',
    dataAnalyticsAI: 'Veri, Analitik & Yapay Zeka',
    processAutomation: 'Süreç Otomasyonu',
    customerExperience: 'Müşteri Deneyimi',
    organizationCulture: 'Organizasyon & Kültür',
    
    // Reports
    generateReport: 'Rapor Oluştur',
    downloadPDF: 'PDF İndir',
    executiveSummary: 'Yönetici Özeti',
    pillarAnalysis: 'Alan Analizi',
    gapAnalysis: 'Boşluk Analizi',
    aiReadiness: 'AI Hazırlık Analizi',
    riskAnalysis: 'Risk Analizi',
    transformationRoadmap: 'Dönüşüm Yol Haritası',
    roiSimulation: 'ROI Simülasyonu',
    priorityMatrix: 'Öncelik Matrisi',
    benchmarkComparison: 'Benchmark Karşılaştırması',
    
    // Benchmark
    industryAverage: 'Sektör Ortalaması',
    globalAverage: 'Global Ortalama',
    topPerformers: 'En İyi %10',
    yourScore: 'Skorunuz',
    percentileRank: 'Yüzdelik Dilim',
    
    // Benchmark Positions
    digitalLeader: 'Dijital Lider',
    aboveAverage: 'Ortalamanın Üstünde',
    industryAveragePos: 'Sektör Ortalaması',
    belowAverage: 'Ortalamanın Altında',
    digitallyLagging: 'Dijital Geciken',
    
    // Company
    addCompany: 'Şirket Ekle',
    companyName: 'Şirket Adı',
    industry: 'Sektör',
    companySize: 'Şirket Büyüklüğü',
    country: 'Ülke',
    employeeCount: 'Çalışan Sayısı',
    annualRevenue: 'Yıllık Gelir',
    
    // Company Sizes
    sme: 'KOBİ',
    midMarket: 'Orta Ölçekli',
    enterprise: 'Kurumsal',
    
    // White Label
    branding: 'Marka Ayarları',
    logoUrl: 'Logo URL',
    primaryColor: 'Ana Renk',
    secondaryColor: 'İkincil Renk',
    
    // Common
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    view: 'Görüntüle',
    loading: 'Yükleniyor...',
    error: 'Hata',
    success: 'Başarılı',
    noData: 'Veri bulunamadı',
    search: 'Ara',
    filter: 'Filtrele',
    export: 'Dışa Aktar',
    import: 'İçe Aktar',
    
    // Question Types
    stronglyDisagree: 'Hiç Katılmıyorum',
    disagree: 'Katılmıyorum',
    neutral: 'Kararsızım',
    agree: 'Katılıyorum',
    stronglyAgree: 'Kesinlikle Katılıyorum',
    
    // Impact/Effort
    highImpact: 'Yüksek Etki',
    mediumImpact: 'Orta Etki',
    lowImpact: 'Düşük Etki',
    highEffort: 'Yüksek Efor',
    mediumEffort: 'Orta Efor',
    lowEffort: 'Düşük Efor',
  },
  en: {
    // Navigation
    dashboard: 'Dashboard',
    assessments: 'Assessments',
    reports: 'Reports',
    companies: 'Companies',
    settings: 'Settings',
    logout: 'Logout',
    
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    fullName: 'Full Name',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    
    // Landing
    heroTitle: 'Digital Maturity Intelligence Platform',
    heroSubtitle: 'Measure your company\'s digital transformation journey with a scientific framework, benchmark results, and receive enterprise-grade consulting reports.',
    startAssessment: 'Start Assessment',
    learnMore: 'Learn More',
    
    // Dashboard
    welcomeBack: 'Welcome Back',
    totalAssessments: 'Total Assessments',
    completedAssessments: 'Completed',
    averageScore: 'Average GDMII',
    companiesCount: 'Registered Companies',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    newAssessment: 'New Assessment',
    viewReports: 'View Reports',
    
    // Assessment
    startNewAssessment: 'Start New Assessment',
    continueAssessment: 'Continue',
    selectCompany: 'Select Company',
    assessmentProgress: 'Assessment Progress',
    questionsAnswered: 'Questions Answered',
    currentPillar: 'Current Pillar',
    nextQuestion: 'Next Question',
    previousQuestion: 'Previous Question',
    submitAssessment: 'Complete Assessment',
    
    // Pillars
    digitalStrategy: 'Digital Strategy & Leadership',
    technologyInfrastructure: 'Technology Infrastructure',
    dataAnalyticsAI: 'Data, Analytics & AI',
    processAutomation: 'Process Automation',
    customerExperience: 'Customer Experience',
    organizationCulture: 'Organization & Culture',
    
    // Reports
    generateReport: 'Generate Report',
    downloadPDF: 'Download PDF',
    executiveSummary: 'Executive Summary',
    pillarAnalysis: 'Pillar Analysis',
    gapAnalysis: 'Gap Analysis',
    aiReadiness: 'AI Readiness Analysis',
    riskAnalysis: 'Risk Analysis',
    transformationRoadmap: 'Transformation Roadmap',
    roiSimulation: 'ROI Simulation',
    priorityMatrix: 'Priority Matrix',
    benchmarkComparison: 'Benchmark Comparison',
    
    // Benchmark
    industryAverage: 'Industry Average',
    globalAverage: 'Global Average',
    topPerformers: 'Top 10%',
    yourScore: 'Your Score',
    percentileRank: 'Percentile Rank',
    
    // Benchmark Positions
    digitalLeader: 'Digital Leader',
    aboveAverage: 'Above Average',
    industryAveragePos: 'Industry Average',
    belowAverage: 'Below Average',
    digitallyLagging: 'Digitally Lagging',
    
    // Company
    addCompany: 'Add Company',
    companyName: 'Company Name',
    industry: 'Industry',
    companySize: 'Company Size',
    country: 'Country',
    employeeCount: 'Employee Count',
    annualRevenue: 'Annual Revenue',
    
    // Company Sizes
    sme: 'SME',
    midMarket: 'Mid-Market',
    enterprise: 'Enterprise',
    
    // White Label
    branding: 'Branding Settings',
    logoUrl: 'Logo URL',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    noData: 'No data found',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    
    // Question Types
    stronglyDisagree: 'Strongly Disagree',
    disagree: 'Disagree',
    neutral: 'Neutral',
    agree: 'Agree',
    stronglyAgree: 'Strongly Agree',
    
    // Impact/Effort
    highImpact: 'High Impact',
    mediumImpact: 'Medium Impact',
    lowImpact: 'Low Impact',
    highEffort: 'High Effort',
    mediumEffort: 'Medium Effort',
    lowEffort: 'Low Effort',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('gdmii-language') || 'tr';
  });
  
  useEffect(() => {
    localStorage.setItem('gdmii-language', language);
  }, [language]);
  
  const t = (key) => {
    return translations[language][key] || key;
  };
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export default LanguageContext;
